import { render, staticRenderFns } from "./GlobeSection.vue?vue&type=template&id=27f8c8f2&"
import script from "./GlobeSection.vue?vue&type=script&lang=js&"
export * from "./GlobeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\marci\\Desktop\\majorel-china-static\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27f8c8f2')) {
      api.createRecord('27f8c8f2', component.options)
    } else {
      api.reload('27f8c8f2', component.options)
    }
    module.hot.accept("./GlobeSection.vue?vue&type=template&id=27f8c8f2&", function () {
      api.rerender('27f8c8f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/templates/GlobeSection.vue"
export default component.exports